const menuItems = document.querySelectorAll('li.ettika--header--menu--list > mega-menu');
menuItems.forEach(megaMenu => {
  const li = megaMenu.parentElement;
  const holdDiv = megaMenu.querySelector('.ettika--header--megamenu--hold');

  const setActive = () => {
    li.classList.add('active');
    holdDiv?.classList.add('active');
    document.body.classList.add('active--header--megamenu');
  };

  const removeActive = () => {
    li.classList.remove('active');
    holdDiv?.classList.remove('active');
    document.body.classList.remove('active--header--megamenu');
  };

  [li, holdDiv].forEach(el => {
    if (!el) return;
    el.addEventListener('mouseenter', setActive);
    el.addEventListener('mouseleave', e => {
      const related = e.relatedTarget;
      if (!li.contains(related) && !(holdDiv && holdDiv.contains(related))) {
        removeActive();
      }
    });
  });
});




// mobile--menu--opener-js
document.querySelector('.ettika--toggle--menu--icon').addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('.ettika--mobile--menu').classList.add('open--ettika');
});
document.querySelectorAll('.mobile--menu--cross--icon').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    document.querySelector('.ettika--mobile--menu').classList.remove('open--ettika');
    document.querySelectorAll('.products--inner--drawer.product--inner--drawer--open').forEach(drawer => {
      drawer.classList.remove('product--inner--drawer--open');
    });
  });
});
document.querySelectorAll('.has--product--drawer--menu').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const drawer = this.nextElementSibling;
    if(drawer && drawer.classList.contains('products--inner--drawer')) {
      drawer.classList.add('product--inner--drawer--open');
    }
  });
});

document.querySelectorAll('.go--back--collection--title').forEach(btn => {
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    const drawer = this.closest('.products--inner--drawer');
    if(drawer) {
      drawer.classList.remove('product--inner--drawer--open');
    }
  });
});

// mobile--drawer--body-class
(function () {
  const drawer = document.querySelector('.ettika--mobile--menu');
  if (!drawer) return;

  const OPEN_CLASS = 'open--ettika';
  const BODY_CLASS = 'ettika--mobile--drawer-open';
  let wasOpen = drawer.classList.contains(OPEN_CLASS);
  let closeToken = 0;

  // How far the header (links strip) currently sits behind the announcement.
  // CSS clips that slice while BODY_CLASS is on, so the lowered announcement
  // isn't painted over. Kept current on scroll only while the class is on.
  const ann = document.querySelector('.announcement-bar-sticky');
  const mainHeader = document.querySelector('.ettika--main--header');
  let overlapRaf = 0;
  const syncOverlap = () => {
    overlapRaf = 0;
    if (!ann || !mainHeader) return;
    const overlap = Math.max(0, ann.getBoundingClientRect().bottom - mainHeader.getBoundingClientRect().top);
    document.documentElement.style.setProperty('--ettika-ann-overlap', overlap + 'px');
  };
  const onOverlapScroll = () => { if (!overlapRaf) overlapRaf = requestAnimationFrame(syncOverlap); };
  const addBodyClass = () => {
    syncOverlap();
    window.addEventListener('scroll', onOverlapScroll, { passive: true });
    document.body.classList.add(BODY_CLASS);
  };

  if (wasOpen) addBodyClass();

  const handleClose = () => {
    const token = ++closeToken;

    // getAnimations() flushes styles, so it returns the transitions/animations
    // the close just triggered on the drawer or any descendant.
    // Infinite animations (spinners, marquees) are ignored so they can't block removal.
    const closing = drawer.getAnimations({ subtree: true }).filter(a =>
      a.playState !== 'finished' &&
      a.effect && a.effect.getComputedTiming().endTime !== Infinity
    );

    const finish = () => {
      // Skip if the drawer was reopened while it was closing
      if (token !== closeToken || drawer.classList.contains(OPEN_CLASS)) return;
      document.body.classList.remove(BODY_CLASS);
      window.removeEventListener('scroll', onOverlapScroll);
    };

    if (!closing.length) { finish(); return; }
    Promise.allSettled(closing.map(a => a.finished)).then(finish);
  };

  new MutationObserver(() => {
    const isOpen = drawer.classList.contains(OPEN_CLASS);
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    if (isOpen) {
      closeToken++; // cancel any pending removal
      addBodyClass();
    } else {
      handleClose();
    }
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
})();
// menu-grid-show-next-after-six-li
  document.addEventListener('DOMContentLoaded', function () {
    const lists = document.querySelectorAll('.megamenu--shop--by--list');
    lists.forEach(list => {
      if (list.classList.contains('mega--shop--by--list--everywhere')) return;
      const itemCount = list.querySelectorAll('li').length;
      if (itemCount > 7) {
        list.classList.add('two-column-layout');
      }
    });
  });

document.addEventListener("DOMContentLoaded", function () {
  const announcement = document.querySelector('.announcement_bar_wrapper');
  const links = document.querySelector('.ettika--main--header--links');
  const wrapper = document.querySelector('.ettika--main--header--wrapper');

  if (!wrapper) return;

  const DESKTOP_BP = 768;

  let annH = 0;
  let linksH = 0;
  let navH = 0;

  const measure = () => {
    annH = announcement ? announcement.offsetHeight : 0;
    linksH = links ? links.offsetHeight : 0;
    navH = wrapper ? wrapper.offsetHeight : 0;

    document.documentElement.style.setProperty('--announcement-h', annH + 'px');
    document.documentElement.style.setProperty('--links-h', linksH + 'px');
    document.documentElement.style.setProperty('--nav-h', navH + 'px');
  };

  let ticking = false;

  const apply = () => {
    ticking = false;

    const y = window.scrollY || 0;

    // ✅ Now mobile announcement is fixed too, so both mobile & desktop
    // should slide only by the links height.
    const startOffset = linksH;
    const translateY = Math.max(0, startOffset - y);

    wrapper.style.transform = `translateY(${translateY}px)`;
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(apply);
    }
  };

  const onResize = () => {
    measure();
    apply();
  };

  measure();
  apply();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);

  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => {
      measure();
      apply();
    });
    if (announcement) ro.observe(announcement);
    if (links) ro.observe(links);
    ro.observe(wrapper);
  }
});





// document.addEventListener("DOMContentLoaded", function () {
//   const headerLinks = document.querySelector('.ettika--main--header--links');
//   const headerWrapper = document.querySelector('.ettika--main--header--wrapper');
//   const placeholderLinks = document.getElementById('sticky-links-placeholder');
//   const placeholderWrapper = document.getElementById('sticky-wrapper-placeholder');

//   let previousScrollY = window.scrollY;
//   const mobileBreakpoint = 768;

//   const updateSticky = () => {
//     const currentScrollY = window.scrollY;
//     const isMobile = window.innerWidth < mobileBreakpoint;

//     const linksHeight = headerLinks.offsetHeight;
//     const wrapperHeight = headerWrapper.offsetHeight;

//     document.documentElement.style.setProperty('--links-height', linksHeight + 'px');

//     if (currentScrollY === 0) {
//       headerLinks.classList.remove('sticky', 'hide');
//       placeholderLinks.style.display = 'none';

//       headerWrapper.classList.remove('sticky', 'scrolled-up');
//       placeholderWrapper.style.display = 'none';

//       previousScrollY = currentScrollY;
//       return;
//     }

//     if (!isMobile) {
//       headerLinks.classList.add('sticky');
//       headerLinks.classList.remove('hide');
//       placeholderLinks.style.height = linksHeight + 'px';
//       placeholderLinks.style.display = 'block';

//       headerWrapper.classList.add('sticky');
//       headerWrapper.classList.remove('scrolled-up');
//       placeholderWrapper.style.height = wrapperHeight + 'px';
//       placeholderWrapper.style.display = 'block';
//     } else {
//       headerLinks.classList.add('sticky');

//       if (currentScrollY > previousScrollY && currentScrollY > 80) {
//         headerLinks.classList.add('hide');
//         headerWrapper.classList.remove('scrolled-up');
//       } else {
//         headerLinks.classList.remove('hide');
//         headerWrapper.classList.add('scrolled-up');
//       }

//       if (currentScrollY > 0) {
//         headerWrapper.classList.add('sticky');
//         placeholderLinks.style.height = linksHeight + 'px';
//         placeholderLinks.style.display = 'block';

//         placeholderWrapper.style.height = wrapperHeight + 'px';
//         placeholderWrapper.style.display = 'block';
//       }
//     }

//     previousScrollY = currentScrollY;
//   };

//   window.addEventListener('scroll', updateSticky);
//   window.addEventListener('resize', updateSticky);
// });